module.exports = __webpack_public_path__ + "static/media/ICON-FURNITURE.b0029a11.svg";